import React, { useState, useMemo } from 'react';
import { Search, Type, AlignLeft, ExternalLink, Pin, Shuffle, Layers, BarChart3, Repeat, CheckCircle2, AlertTriangle, Puzzle, Zap, Info, ArrowRight, MousePointerClick } from 'lucide-react';

const ht = (text, pin) => (pin ? { text, pin } : text);
const getText = (h) => (typeof h === 'string' ? h : h.text);
const getPin = (h) => (typeof h === 'object' && h !== null ? h.pin : null);

const STRENGTH = {
  Excellent: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  Good: 'bg-sky-50 text-sky-700 border-sky-200',
  Average: 'bg-amber-50 text-amber-700 border-amber-200',
  Poor: 'bg-red-50 text-red-700 border-red-200',
  Pending: 'bg-gray-100 text-gray-500 border-gray-200',
};

const AD_DATA = [
  {
    campaign: 'V3_SRCH_BRND',
    label: 'Gürgençler (Brand)',
    ads: [
      {
        adGroup: 'Gürgençler',
        strength: 'Excellent',
        headlines: [
          'Gürgençler', 'Gurgencler.com.tr', 'Apple Premium Partner',
          'Apple Yetkili Satış Noktası', 'Apple Ürünlerinde Fırsatlar',
          "Apple'a dair her şey", 'Size en yakın Apple Partneri',
          'Değiş Tokuş Fırsatı', 'Apple Resmi Satış Partneri',
          "Apple Watch Gürgençler'de", 'Aradığın Apple Ürünleri Burada',
          'Online Satış Mağazası', 'Apple Resmi Partner', 'Apple Deneyimi',
        ],
        descriptions: [
          "Tüm Apple ürün ve aksesuarlarında kaçırılmayacak fırsatlar Gürgençler'de.",
          'Eski telefonunuzu getirin 4.000 TL ek destek ve Değiş Tokuş fırsatıyla iPhone sahibi olun',
          "Alışveriş Kredisi'yle iPhone alışverişlerinizde vade farksız 3 taksit fırsatı.",
          "Yepyeni iPhone fırsatları Gürgençler'de.",
        ],
        path: 'gürgençler / apple',
        url: 'https://www.gurgencler.com.tr/',
      },
    ],
  },
  {
    campaign: 'SRCH_Competitor',
    label: 'Rakipler',
    ads: [
      {
        adGroup: 'competitor1',
        strength: 'Poor',
        headlines: [
          'Gürgençler', 'Gurgencler.com.tr', 'Apple Premium Partner',
          'Apple Yetkili Satış Noktası', 'Apple Ürünlerinde Fırsatlar',
          "Apple'a dair her şey", 'Size en yakın Apple Partneri',
          'Değiş Tokuş Fırsatı', 'Apple Resmi Satış Partneri',
          "Apple Watch Gürgençler'de", 'Aradığın Apple Ürünleri Burada',
          'Online Satış Mağazası', 'Apple Resmi Partner', 'Apple Deneyimi',
        ],
        descriptions: [
          "Tüm Apple ürün ve aksesuarlarında kaçırılmayacak fırsatlar Gürgençler'de.",
          'Eski telefonunuzu getirin 4.000 TL ek destek ve Değiş Tokuş fırsatıyla iPhone sahibi olun',
          "Alışveriş Kredisi'yle iPhone alışverişlerinizde vade farksız 3 taksit fırsatı.",
          "Yepyeni iPhone fırsatları Gürgençler'de.",
        ],
        path: 'gürgençler / apple',
        url: 'https://www.gurgencler.com.tr/',
      },
      {
        adGroup: 'competitor2',
        strength: 'Pending',
        headlines: [
          'Gürgençler', 'Gurgencler.com.tr', 'Apple Premium Partner',
          'Apple Yetkili Satış Noktası', 'Apple Ürünlerinde Fırsatlar',
          "Apple'a dair her şey", 'Size en yakın Apple Partneri',
          'Değiş Tokuş Fırsatı', 'Apple Resmi Satış Partneri',
          "Apple Watch Gürgençler'de", 'Aradığın Apple Ürünleri Burada',
          'Online Satış Mağazası', 'Apple Resmi Partner', 'Apple Deneyimi',
        ],
        descriptions: [
          "Tüm Apple ürün ve aksesuarlarında kaçırılmayacak fırsatlar Gürgençler'de.",
          'Eski telefonunuzu getirin 4.000 TL ek destek ve Değiş Tokuş fırsatıyla iPhone sahibi olun',
          "Alışveriş Kredisi'yle iPhone alışverişlerinizde vade farksız 3 taksit fırsatı.",
          "Yepyeni iPhone fırsatları Gürgençler'de.",
        ],
        path: 'gürgençler / apple',
        url: 'https://www.gurgencler.com.tr/',
      },
    ],
  },
  {
    campaign: 'SRCH_GNRC_iPhone17Pro',
    label: 'iPhone 17 Pro',
    ads: [
      {
        adGroup: 'iPhone 17 Pro',
        strength: 'Poor',
        headlines: [
          ht("iPhone 17 Pro Gürgençler'de", 1),
          'Yeni iPhone 17 Pro satışta.',
          'Yeni iPhone 17 Pro.',
          'iPhone 17 Pro siparişi verin',
          ht('iPhone 17 Pro', 2),
          'iPhone 17 Pro satışta.',
          'iPhone 17 Pro. Değiş Tokuş',
          'iPhone 17 Pro.',
          'iPhone 17 Pro sizinle.',
          'Yepyeni iPhone 17 Pro.',
          'Her yönüyle Pro.',
        ],
        descriptions: [
          ht('iPhone 17 Pro. Bugüne kadarki en güçlü iPhone. Göz alıcı 6.3 inç ekran', 1),
          ht('Çığır Açıcı Pil Ömrü Değiş Tokuş fırsatı ve 3 taksit avantajıyla mağazalarımızda.', 2),
        ],
        path: 'iPhone / 17Pro',
        url: 'https://www.gurgencler.com.tr/iphone/iphone-17-pro',
      },
      {
        adGroup: 'iPhone 17 Pro Max',
        strength: 'Average',
        headlines: [
          'iPhone 17 Pro Max Gürgençlerde',
          'Yeni iPhone 17 Pro Max satışta',
          'Yeni iPhone 17 Pro Max.',
          'iPhone 17 Pro Max satın alın.',
          'En gelişmiş Pro.',
          'Son teknoloji Pro.',
          'iPhone 17 Pro Max. Değiş Tokuş',
          'iPhone 17 Pro Max.',
          'iPhone 17 Pro Max sizinle.',
          'Yepyeni iPhone 17 Pro Max.',
          'iPhone 17 Pro Max sahibi olun.',
        ],
        descriptions: [
          'iPhone 17 Pro Max. Bugüne kadarki en güçlü iPhone. Göz alıcı 6.9 inç ekran.',
          'YEKPARE TASARIM. OLAĞANÜSTÜ GÜÇ.',
          'SON TEKNOLOJİ PRO KAMERA SİSTEMİ. — Her biri 48 MP arka kameralar ve optik kalitede zoom',
          '18MP Center Stage Ön Kamera. Alışveriş kredisine özel vade farksız 3 taksit fırsatıyla.',
        ],
        url: 'https://www.gurgencler.com.tr/iphone/iphone-17-pro',
      },
    ],
  },
  {
    campaign: 'SRCH_GNRC_iPhone17',
    label: 'iPhone 17',
    ads: [
      {
        adGroup: 'iPhone 17',
        strength: 'Average',
        headlines: [
          "iPhone 17. Gürgençler'de.",
          'Yeni iPhone 17 satışta.',
          'Yeni iPhone 17.',
          'iPhone 17 satın alın.',
          'iPhone 17 sizinle.',
          'Renkarnasyon. Yeni iPhone 17.',
          'iPhone 17. Değiş Tokuş',
          "iPhone 17'yi keşfedin.",
          'iPhone 17 sahibi olun.',
          'Alışveriş Kredisi ile 3 Taksit',
        ],
        descriptions: [
          "Gürgençler'de satışta — büyüleyici fotograflar. Gelişmiş 48 MP Dual Fusion kamera sistemi",
          'Daha parlak 6.3 inç ekran. Çizilmelere karşı 3 kat daha dayanıklı Ceramic Shield.',
          "Alışveriş Kredisine özel vade farksız 3 taksit avantajıyla Gürgençler mağazalarında.",
        ],
        path: 'Gürgençler / iPhone-17',
        url: 'https://www.gurgencler.com.tr/iphone/iphone-17',
      },
    ],
  },
  {
    campaign: 'SRCH_GNRC_iPhoneAir',
    label: 'iPhone Air',
    ads: [
      {
        adGroup: 'iPhone Air',
        strength: 'Poor',
        headlines: [
          "iPhone Air Gürgençler'de.",
          'Apple iPhone Air',
          'Yeni iPhone Air',
          'iPhone Air Satın Alın',
          'Karşınızda iPhone Air',
          "iPhone Air Gürgençler'de",
          'Yeni iPhone Air Gürgençlerde',
          'iPhone Air sahibi olun.',
          "Apple iPhone Air Gürgençler'de",
          'Yeni Apple iPhone Air',
          'iPhone Air',
          'Gürgençler Apple iPhone Air',
        ],
        descriptions: [
          'Süper İncelik, Şaşırtıcı Hafiflik, Çarpıcı Dayanıklılık',
          "48 MP Fusion kamera sistemi ve Center Stage ön kamerası ile Gürgençler'de satışta.",
          "A19 Pro Çip, Süper Hızlı, Süper Verimli Gürgençler'de sahip olun.",
        ],
        path: 'iPhone / air',
        url: 'https://www.gurgencler.com.tr/iphone/iphone-air',
      },
    ],
  },
  {
    campaign: 'SRCH_GNRC_iPad_A16',
    label: 'iPad (A16)',
    ads: [
      {
        adGroup: 'iPad',
        strength: 'Average',
        headlines: [
          'A16 çipli iPad',
          'Güçlü ve Hafif iPad',
          "\u2060En Yeni iPad Gürgençler'de",
          ht('iPad Air M3', 2),
          'Vade Farksız 6 Taksit Avantajı',
          "Gürgençler'den iPad Al",
          'Apple Premium Partner Farkıyla',
          'iPad ile Güç ve Esneklik',
          'En Yeni A16 çipli iPad Modeli',
          'A16 Çip ile Daha Fazlasını Yap',
          'iPad Gürgençler Mağazalarında',
        ],
        descriptions: [
          "A16 çipli yeni iPad, Gürgençler Apple Premium Partner'de satışta.",
          'iPad ile yaratıcılığınızı güçlendirin. Gürgençler güvencesiyle iPad sahibi olun.',
          "A16 çipli iPad, vade farksız 6 taksit fırsatıyla. Gürgençler'de.",
          "Eğitime özel A16 çipli iPad'e Gürgençler'de sahip olun.",
        ],
        path: 'Apple / iPad',
        url: 'https://www.gurgencler.com.tr/ipad/ipad',
      },
    ],
  },
  {
    campaign: 'SRCH_GNRC_iPad_air',
    label: 'iPad Air',
    ads: [
      {
        adGroup: 'iPad (11-inch)',
        strength: 'Average',
        headlines: [
          'iPad Air',
          'Güçlü ve Hafif iPad',
          "\u2060En Yeni iPad Gürgençler'de",
          ht('iPad Air M3', 2),
          'Vade Farksız 6 Taksit Avantajı',
          "Gürgençler'den iPad Al",
          'Apple Premium Partner Farkıyla',
          'iPad ile Güç ve Esneklik',
          '6 Ay Vade Farksız Taksit',
          'M3 Çip ile Daha Fazlasını Yap',
          'iPad Gürgençler Mağazalarında',
        ],
        descriptions: [
          "M3 çipli yeni iPad, Gürgençler Apple Premium Partner'de satışta.",
          'iPad ile yaratıcılığınızı güçlendirin. Gürgençler güvencesiyle iPad sahibi olun.',
          "M3 çipli iPad, vade farksız 6 taksit fırsatıyla. Gürgençler'de.",
          "Eğitime özel M3 çipli iPad'e Gürgençler'de sahip olun.",
        ],
        path: 'Apple / iPad',
        url: 'https://www.gurgencler.com.tr/ipad/ipad-air',
      },
      {
        adGroup: 'iPad 13-inch',
        strength: 'Average',
        headlines: [
          'iPad Air 13 inch',
          'Güçlü ve Hafif iPad',
          "\u2060En Yeni iPad Gürgençler'de",
          ht('iPad Air M3 13 inch', 2),
          'Vade Farksız 6 Taksit Avantajı',
          "Gürgençler'den iPad Al",
          'Apple Premium Partner Farkıyla',
          'iPad ile Güç ve Esneklik',
          '6 Ay Vade Farksız Taksit',
          'M3 Çip ile Daha Fazlasını Yap',
          'iPad Gürgençler Mağazalarında',
        ],
        descriptions: [
          "M3 çipli yeni iPad, Gürgençler Apple Premium Partner'de satışta.",
          'iPad ile yaratıcılığınızı güçlendirin. Gürgençler güvencesiyle iPad sahibi olun.',
          "M3 çipli iPad, vade farksız 6 taksit fırsatıyla. Gürgençler'de.",
          "Eğitime özel M3 çipli iPad'e Gürgençler'de sahip olun.",
        ],
        path: 'Apple / iPad',
        url: 'https://www.gurgencler.com.tr/ipad/ipad-air',
      },
    ],
  },
  {
    campaign: 'SRCH_GNRC_iPad_mini',
    label: 'iPad Mini',
    ads: [
      {
        adGroup: 'iPad_mini',
        strength: 'Average',
        headlines: [
          'iPad Mini',
          'Güçlü ve Hafif iPad',
          "\u2060En Yeni iPad Gürgençler'de",
          ht("iPad Mini Gürgençler'de", 2),
          'Vade Farksız 6 Taksit Avantajı',
          "Gürgençler'den iPad Al",
          'Apple Premium Partner Farkıyla',
          'iPad ile Güç ve Esneklik',
          'En Yeni A16 çipli iPad Modeli',
          'iPad Mini ile Daha Fazlası',
          'iPad Gürgençler Mağazalarında',
        ],
        descriptions: [
          "iPad Mini, Gürgençler Apple Premium Partner'de satışta.",
          'iPad ile yaratıcılığınızı güçlendirin. Gürgençler güvencesiyle iPad sahibi olun.',
          "iPad Mini, vade farksız 6 taksit fırsatıyla. Gürgençler'de.",
          "Eğitime özel iPad Mini Gürgençler'de sahip olun.",
        ],
        path: 'Apple / iPad',
        url: 'https://www.gurgencler.com.tr/ipad/ipad-mini',
      },
    ],
  },
  {
    campaign: 'SRCH_GNRC_iPadM5',
    label: 'iPad Pro M5',
    ads: [
      {
        adGroup: 'ipadM5',
        strength: 'Average',
        headlines: [
          "iPad Pro M5 Gürgençler'de.",
          'Yeni M5 Çipli iPad Pro',
          'yeni iPad Pro',
          'ipad Pro M5 Çipli',
          'Süper güçlü M5 çip ile',
          'Vade farksız 6 taksit',
          'Profesyonel ve Yaratıcı',
          "iPad Pro Güç 5'inde",
        ],
        descriptions: [
          "Süper güçlü M5 çip ile yeni iPad Pro şimdi Gürgençler'de",
          "Süper güçlü M5 çip ile şimdi Gürgençler'de, vade farksız 6 taksit avantajıyla!",
        ],
        path: 'iPad / Pro',
        url: 'https://www.gurgencler.com.tr/ipad/ipad-pro',
      },
    ],
  },
  {
    campaign: 'SRCH_GNRC_AirpodsPro3',
    label: 'AirPods Pro 3',
    ads: [
      {
        adGroup: 'Airpods Pro 3',
        strength: 'Poor',
        headlines: [
          'AirPods Pro 3.',
          'Yeni AirPods Pro 3.',
          'AirPods Pro 3 satışta',
          'AirPods Pro 3 Satışta',
          'AirPods Pro 3. Sizinle',
          'AirPods Pro 3. sahibi ol.',
          "AirPods Pro 3 Gürgençler'de",
          'AirPods Pro 3 satın alın',
          'Yepyeni AirPods Pro 3.',
        ],
        descriptions: [
          "AirPods Pro 3. Şimdi Kalp Atış Hızı Algılama özelliğiyle Gürgençler'de satışta.",
          "AirPods Pro 3. Çığır açıcı bir Aktif Gürültü Engelleme deneyimi Gürgençler'de satışta.",
          "Daha Uzun Pil Ömrü şarjla 8 saate kadar dinleme süresi. Gürgençler'de satışta.",
        ],
        url: 'https://www.gurgencler.com.tr/airpods/airpods-pro',
      },
    ],
  },
  {
    campaign: 'SRCH_GNRC_Watch11',
    label: 'Apple Watch Series 11',
    ads: [
      {
        adGroup: 'Apple Watch Series 11',
        strength: 'Good',
        headlines: [
          'Apple Watch Series 11',
          'Yeni Apple Watch Series 11',
          'Apple Watch Series 11 satışta',
          'Apple Watch Series 11 satın al',
          'Apple Watch Series 11 sizinle',
          'Apple Watch sahibi ol.',
          "Apple Watch Gürgençler'de",
          'Apple Watch satın alın.',
          "Watch Series 11 Gürgençler'de",
          'Sevgililer Gününe Özel',
          'Mükemmel Hediyenin Adı',
        ],
        descriptions: [
          'Sağlıklı bir hayatın tam saati.',
          'Çok Daha Fazla Sağlık Bilgisi — Apple Watch Series 11.',
          "Büyüleyici Tasarım. İnce ve hafif tasarıma sahip Apple Watch Series 11 Gürgençler'de",
        ],
        url: 'https://www.gurgencler.com.tr/apple-watch/apple-watch-series-11',
      },
    ],
  },
  {
    campaign: 'SRCH_GNRC_WatchSE3',
    label: 'Apple Watch SE 3',
    ads: [
      {
        adGroup: 'Apple Watch SE 3',
        strength: 'Average',
        headlines: [
          'Apple Watch SE 3',
          'Yeni Apple Watch SE 3',
          'Apple Watch SE 3 satışta',
          'Apple Watch SE 3 satın al',
          'Apple Watch SE 3. Sizinle',
          'Apple Watch sahibi ol.',
          "Apple Watch Gürgençler'de",
          'Apple Watch SE 3 satın alın.',
          "Apple Watch SE 3 Gürgençler'de",
          'Watch SE 3. Şimdi satışta',
          'Apple Watch SE 3 GPS+Cellular',
          'Sevgililer Gününe Özel',
          'Mükemmel Hediyenin Adı',
        ],
        descriptions: [
          'Süper bir fiyata süper güçlere sahip olun.',
          'MÜTHİŞ BİR PİL ÖMRÜ — Tüm gün süren 18 saatlik pil ömrünün keyfini çıkarın.',
          "Değiş Tokuş ve vade farksız 6 taksit fırsatıyla şimdi ayda 2.333 TL'ye Gürgençler'de.",
          "HAREKET HALİNDEYKEN BAĞLANTIDA KALIN — iPhone'unuz yanınızda olmasa bile arama yapın.",
        ],
        url: 'https://www.gurgencler.com.tr/apple-watch/apple-watch-se-3',
      },
    ],
  },
  {
    campaign: 'SRCH_GNRC_WatchUltra3',
    label: 'Apple Watch Ultra 3',
    ads: [
      {
        adGroup: 'Watch Ultra 3',
        strength: 'Poor',
        headlines: [
          'Apple Watch Ultra 3',
          'Yeni Apple Watch Ultra 3',
          'Apple Watch Ultra 3 satışta',
          'Apple Watch Ultra 3 satın al',
          'Apple Watch Ultra 3. Sizinle',
          'Apple Watch sahibi ol.',
          "Apple Watch Gürgençler'de",
          'Apple Watch Ultra 3 satın alın',
          "Watch Ultra 3 Gürgençler'de",
          'Watch Ultra 3 Satışta',
        ],
        descriptions: [
          'İçinizdeki canavar şimdi kolunuzda.',
          'Spor ve macera için mükemmel saat.',
          "Değiş Tokuş ve vade farksız 6 taksit fırsatıyla şimdi ayda 2.333 TL'ye Gürgençler'de.",
          "Yeni Apple Watch Ultra 3 Çok daha uzun pil ömrü. — Gürgençler'de satışta.",
        ],
        url: 'https://www.gurgencler.com.tr/apple-watch/apple-watch-ultra-3',
      },
    ],
  },
  {
    campaign: 'SRCH_GNRC_Macbook',
    label: 'MacBook',
    ads: [
      {
        adGroup: 'Macbook',
        strength: 'Average',
        headlines: [
          'Macbook',
          'Apple MacBook Gürgençler',
          ht('Vade Farksız 12 Taksit', 2),
          'Apple MacBook Modelleri',
          'Vade Farksız 12 Taksit Fırsatı',
          'Gürgençler | MacBook',
          'Apple Premium Partner Farkıyla',
          'MacBook ile Güç ve Esneklik',
          'M4 Çipli MacBook Air',
          'MacBook Air ile Daha Fazlası',
          'MacBook Air M4 Fırsatı',
        ],
        descriptions: [
          "MacBook Modelleri, Gürgençler Apple Premium Partner'de satışta.",
          'MacBook Air ile yaratıcılığınızı güçlendirin. Gürgençler güvencesiyle MacBook sahibi olun.',
          "MacBook Air M4 vade farksız 12 taksit fırsatıyla. Gürgençler'de.",
        ],
        path: 'Apple / MacBook',
        url: 'https://www.gurgencler.com.tr/mac/macbook-air',
      },
    ],
  },
  {
    campaign: 'SRCH_GNRC_Macbook_Air_M4',
    label: 'MacBook Air M4',
    ads: [
      {
        adGroup: 'Macbook_Air_M4',
        strength: 'Average',
        headlines: [
          'Macbook Air Gücü',
          'Apple MacBook Air Gürgençler',
          ht('Vade Farksız 12 Taksit', 2),
          'Apple MacBook Air',
          'Vade Farksız 12 Taksit Fırsatı',
          'Gürgençler | MacBook',
          'Apple Premium Partner Farkıyla',
          'MacBook ile Güç ve Esneklik',
          'M4 Çipli MacBook Air',
          'MacBook Air ile Daha Fazlası',
          'MacBook Air Fırsatı',
        ],
        descriptions: [
          "MacBook Air, Gürgençler Apple Premium Partner'de satışta.",
          'MacBook Air ile yaratıcılığınızı güçlendirin. Gürgençler güvencesiyle MacBook sahibi olun.',
          "MacBook Air vade farksız 12 taksit fırsatıyla. Gürgençler'de.",
        ],
        path: 'Apple / MacBook',
        url: 'https://www.gurgencler.com.tr/mac/macbook-air',
      },
    ],
  },
  {
    campaign: 'SRCH_GNRC_Macbook_Pro_M4',
    label: 'MacBook Pro M4',
    ads: [
      {
        adGroup: 'Macbook_Pro_M4',
        strength: 'Average',
        headlines: [
          'MacBook Pro Gücü',
          'MacBook Pro Gürgençler',
          "MacBook Pro Gürgençler'de",
          'Apple MacBook Pro',
          ht('Vade Farksız 12 Taksit Fırsatı', 2),
          'Gürgençler | MacBook',
          'Apple Premium Partner Farkıyla',
          'MacBook ile Güç ve Esneklik',
          'M4 Çipli MacBook Pro',
          'MacBook Pro ile Daha Fazlası',
          'MacBook Pro Fırsatı',
        ],
        descriptions: [
          "MacBook Pro, Gürgençler Apple Premium Partner'de satışta.",
          'MacBook Pro ile yaratıcılığınızı güçlendirin. Gürgençler güvencesiyle MacBook sahibi olun.',
          "MacBook Pro vade farksız 12 taksit fırsatıyla. Gürgençler'de.",
        ],
        path: 'Apple / MacBook',
        url: 'https://www.gurgencler.com.tr/mac/macbook-pro',
      },
    ],
  },
];

const totalAds = AD_DATA.reduce((s, c) => s + c.ads.length, 0);

export default function AdCopyReport() {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredData = useMemo(() => {
    const q = searchQuery.toLowerCase().trim();
    if (!q) return AD_DATA;
    return AD_DATA.map(c => ({
      ...c,
      ads: c.ads.filter(ad =>
        ad.headlines.some(h => getText(h).toLowerCase().includes(q)) ||
        ad.descriptions.some(d => (typeof d === 'string' ? d : d.text).toLowerCase().includes(q)) ||
        c.label.toLowerCase().includes(q) ||
        ad.adGroup.toLowerCase().includes(q)
      ),
    })).filter(c => c.ads.length > 0);
  }, [searchQuery]);

  const filteredAds = useMemo(() => filteredData.reduce((s, c) => s + c.ads.length, 0), [filteredData]);

  return (
    <div className="min-h-screen p-4 md:p-6 space-y-6 max-w-screen-2xl mx-auto bg-[#f6f8ff]/70">
      <div className="bg-white p-5 rounded-2xl shadow-sm border border-gray-100">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
          <div className="flex items-center gap-4">
            <div className="p-3 bg-blue-50 border border-blue-100 shadow-sm rounded-xl">
              <img src="/google_ads.webp" alt="Google Ads" className="w-8 h-8 object-contain" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Ad Copy Report — Gürgençler</h1>
              <p className="text-sm text-gray-500 mt-0.5">Kampanya bazlı reklam metinleri ve açıklamalar</p>
            </div>
          </div>
          <div className="flex items-center gap-3 text-sm flex-wrap">
            <span className="px-3 py-1.5 bg-blue-50 text-blue-700 rounded-lg font-medium">{filteredData.length} Kampanya</span>
            <span className="px-3 py-1.5 bg-indigo-50 text-indigo-700 rounded-lg font-medium">{filteredAds} Reklam</span>
          </div>
        </div>
      </div>

      <div className="relative">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
        <input
          type="text"
          placeholder="Headline, açıklama veya kampanya ara..."
          className="w-full pl-11 pr-4 py-3 bg-white border border-gray-200 rounded-2xl text-sm shadow-sm focus:ring-2 focus:ring-blue-100 focus:border-blue-300 outline-none transition-all"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <div className="space-y-4">
        {filteredData.map((c) => (
          <div key={c.campaign} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
            <div className="px-5 py-4 border-b border-gray-50 bg-gray-50/50">
              <div className="flex items-center justify-between">
                <h2 className="font-semibold text-gray-900 text-lg">{c.label}</h2>
                <span className="text-[10px] font-mono text-gray-400 bg-gray-100 px-2 py-0.5 rounded">{c.campaign}</span>
              </div>
            </div>

            <div className="divide-y divide-gray-50">
              {c.ads.map((ad, adIdx) => (
                <div key={adIdx} className="p-5 space-y-4">
                  <div className="flex items-center justify-between flex-wrap gap-2">
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-medium text-gray-700">{ad.adGroup}</span>
                      {ad.path && (
                        <span className="text-xs text-gray-400 bg-gray-50 px-2 py-0.5 rounded">
                          {ad.path}
                        </span>
                      )}
                    </div>
                    <div className="flex items-center gap-2">
                      <span className={`text-[11px] font-semibold px-2.5 py-1 rounded-full border ${STRENGTH[ad.strength] || STRENGTH.Pending}`}>
                        {ad.strength}
                      </span>
                      <a
                        href={ad.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-xs text-blue-500 hover:text-blue-700 flex items-center gap-1 transition-colors"
                      >
                        <ExternalLink className="w-3 h-3" />
                        {ad.url.replace('https://www.', '').replace(/\/$/, '')}
                      </a>
                    </div>
                  </div>

                  <div>
                    <div className="flex items-center gap-1.5 mb-2">
                      <Type className="w-3.5 h-3.5 text-indigo-500" />
                      <span className="text-xs font-semibold text-indigo-600 uppercase tracking-wider">Headline'lar</span>
                      <span className="text-[10px] text-gray-400 ml-1">({ad.headlines.length})</span>
                    </div>
                    <div className="flex flex-wrap gap-1.5">
                      {ad.headlines.map((h, i) => {
                        const text = getText(h);
                        const pin = getPin(h);
                        return (
                          <span
                            key={i}
                            className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg border bg-indigo-50/70 border-indigo-200/60 text-indigo-800 text-xs font-medium"
                          >
                            <span className="text-[10px] text-indigo-400 font-bold min-w-[14px]">H{i + 1}</span>
                            {text}
                            {pin && (
                              <span className="inline-flex items-center gap-0.5 text-[9px] font-bold text-orange-600 bg-orange-50 border border-orange-200 px-1 py-0.5 rounded ml-0.5">
                                <Pin className="w-2.5 h-2.5" />
                                {pin}
                              </span>
                            )}
                          </span>
                        );
                      })}
                    </div>
                  </div>

                  <div>
                    <div className="flex items-center gap-1.5 mb-2">
                      <AlignLeft className="w-3.5 h-3.5 text-emerald-500" />
                      <span className="text-xs font-semibold text-emerald-600 uppercase tracking-wider">Açıklamalar</span>
                      <span className="text-[10px] text-gray-400 ml-1">({ad.descriptions.length})</span>
                    </div>
                    <div className="space-y-1.5">
                      {ad.descriptions.map((d, i) => {
                        const text = typeof d === 'string' ? d : d.text;
                        const pin = typeof d === 'object' ? d.pin : null;
                        return (
                          <div
                            key={i}
                            className="flex items-start gap-2 px-3 py-2 rounded-lg border bg-emerald-50/50 border-emerald-200/50 text-sm text-gray-800"
                          >
                            <span className="text-[10px] text-emerald-500 font-bold mt-0.5 min-w-[16px] flex-shrink-0">D{i + 1}</span>
                            <span className="flex-1">{text}</span>
                            {pin && (
                              <span className="inline-flex items-center gap-0.5 text-[9px] font-bold text-orange-600 bg-orange-50 border border-orange-200 px-1 py-0.5 rounded flex-shrink-0">
                                <Pin className="w-2.5 h-2.5" />
                                {pin}
                              </span>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {filteredData.length === 0 && (
        <div className="bg-white rounded-2xl p-12 text-center shadow-sm border border-gray-100">
          <Search className="w-12 h-12 text-gray-300 mx-auto mb-3" />
          <h3 className="text-lg font-medium text-gray-700">Sonuç bulunamadı</h3>
          <p className="text-sm text-gray-500 mt-1">Arama terimini değiştirmeyi dene</p>
        </div>
      )}

      <div className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100">
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-gray-500">
          <span className="font-medium text-gray-600">Reklam Gücü:</span>
          {Object.entries(STRENGTH).map(([key, cls]) => (
            <span key={key} className="flex items-center gap-1.5">
              <span className={`w-3 h-3 rounded border ${cls}`}></span> {key}
            </span>
          ))}
          <span className="mx-1 text-gray-300">|</span>
          <span className="flex items-center gap-1">
            <Pin className="w-3 h-3 text-orange-500" /> Sabitlenmiş pozisyon
          </span>
        </div>
      </div>

      {/* --- RSA SİSTEMİ AÇIKLAMASI --- */}
      <div className="space-y-4">
        <div className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 rounded-2xl p-8 shadow-lg border border-slate-700 text-white">
          <div className="flex items-center gap-3 mb-2">
            <div className="p-2 bg-blue-500/20 rounded-xl border border-blue-400/30">
              <Info className="w-6 h-6 text-blue-400" />
            </div>
            <div>
              <h2 className="text-xl font-bold">Duyarlı Arama Reklamları (RSA) Nasıl Çalışır?</h2>
              <p className="text-sm text-slate-400 mt-0.5">Google Ads reklam varyasyonları ve extension sistemi</p>
            </div>
          </div>
        </div>

        {/* SLIDE 1 — RSA Nedir */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 space-y-5">
          <div className="flex items-center gap-2">
            <span className="text-xs font-bold text-white bg-blue-600 px-2.5 py-1 rounded-full">1</span>
            <h3 className="text-lg font-bold text-gray-900">RSA (Responsive Search Ads) Nedir?</h3>
          </div>
          <p className="text-sm text-gray-600 leading-relaxed">
            Duyarlı arama reklamları, Google'a birden fazla <strong>headline (başlık)</strong> ve <strong>description (açıklama)</strong> vermenizi sağlar.
            Google'ın yapay zekası bu metinleri otomatik olarak farklı kombinasyonlarda test ederek en iyi performansı gösteren varyasyonu kullanıcılara sunar.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <div className="bg-indigo-50 rounded-xl p-4 border border-indigo-100">
              <div className="flex items-center gap-2 mb-2">
                <Type className="w-4 h-4 text-indigo-600" />
                <span className="text-sm font-semibold text-indigo-800">15'e kadar Headline</span>
              </div>
              <p className="text-xs text-indigo-600">Google her gösterimde bu 15 başlıktan en fazla <strong>3 tanesini</strong> seçerek gösterir.</p>
            </div>
            <div className="bg-emerald-50 rounded-xl p-4 border border-emerald-100">
              <div className="flex items-center gap-2 mb-2">
                <AlignLeft className="w-4 h-4 text-emerald-600" />
                <span className="text-sm font-semibold text-emerald-800">4'e kadar Description</span>
              </div>
              <p className="text-xs text-emerald-600">Google her gösterimde bu 4 açıklamadan en fazla <strong>2 tanesini</strong> seçerek gösterir.</p>
            </div>
            <div className="bg-amber-50 rounded-xl p-4 border border-amber-100">
              <div className="flex items-center gap-2 mb-2">
                <Shuffle className="w-4 h-4 text-amber-600" />
                <span className="text-sm font-semibold text-amber-800">Binlerce Kombinasyon</span>
              </div>
              <p className="text-xs text-amber-600">15 headline ve 4 description ile <strong>43.680+</strong> farklı reklam varyasyonu oluşturulabilir.</p>
            </div>
          </div>
        </div>

        {/* SLIDE 2 — Varyasyon Akışı */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 space-y-5">
          <div className="flex items-center gap-2">
            <span className="text-xs font-bold text-white bg-blue-600 px-2.5 py-1 rounded-full">2</span>
            <h3 className="text-lg font-bold text-gray-900">Bir Reklam Gösterimi Nasıl Oluşur?</h3>
          </div>

          <div className="flex flex-col md:flex-row items-stretch gap-3">
            <div className="flex-1 bg-slate-50 rounded-xl p-4 border border-slate-200 flex flex-col items-center text-center">
              <div className="w-10 h-10 bg-indigo-100 rounded-full flex items-center justify-center mb-2">
                <Layers className="w-5 h-5 text-indigo-600" />
              </div>
              <span className="text-sm font-semibold text-gray-800 mb-1">Havuz</span>
              <p className="text-xs text-gray-500">15 headline + 4 description hepsi bir havuzda bekler</p>
            </div>
            <div className="flex items-center justify-center">
              <ArrowRight className="w-5 h-5 text-gray-300 rotate-90 md:rotate-0" />
            </div>
            <div className="flex-1 bg-slate-50 rounded-xl p-4 border border-slate-200 flex flex-col items-center text-center">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mb-2">
                <Shuffle className="w-5 h-5 text-blue-600" />
              </div>
              <span className="text-sm font-semibold text-gray-800 mb-1">Google AI Seçimi</span>
              <p className="text-xs text-gray-500">Kullanıcı, cihaz, konum ve arama sorgusuna göre en iyi 3H + 2D seçilir</p>
            </div>
            <div className="flex items-center justify-center">
              <ArrowRight className="w-5 h-5 text-gray-300 rotate-90 md:rotate-0" />
            </div>
            <div className="flex-1 bg-slate-50 rounded-xl p-4 border border-slate-200 flex flex-col items-center text-center">
              <div className="w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center mb-2">
                <MousePointerClick className="w-5 h-5 text-emerald-600" />
              </div>
              <span className="text-sm font-semibold text-gray-800 mb-1">Reklam Gösterimi</span>
              <p className="text-xs text-gray-500">Seçilen başlık ve açıklamalar + extension'lar birlikte kullanıcıya gösterilir</p>
            </div>
          </div>
        </div>

        {/* SLIDE 3 — Extension'lar */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 space-y-5">
          <div className="flex items-center gap-2">
            <span className="text-xs font-bold text-white bg-blue-600 px-2.5 py-1 rounded-full">3</span>
            <h3 className="text-lg font-bold text-gray-900">Extension (Uzantı) Sistemi</h3>
          </div>
          <p className="text-sm text-gray-600 leading-relaxed">
            RSA metinlerinin yanı sıra, <strong>Callout</strong>, <strong>Sitelink</strong>, <strong>Structured Snippet</strong> gibi extension'lar da reklam ile birlikte gösterilir.
            Bu uzantılar ayrı bir havuzda yaşar ve Google hangi uzantıyı göstereceğini de otomatik belirler.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
            <div className="rounded-xl p-4 border border-blue-100 bg-blue-50/50">
              <span className="text-xs font-bold text-blue-700">Sitelink</span>
              <p className="text-[11px] text-blue-600 mt-1">Reklamın altında ek linkler. "12 Taksit Fırsatı", "Değiş Tokuş" gibi.</p>
            </div>
            <div className="rounded-xl p-4 border border-purple-100 bg-purple-50/50">
              <span className="text-xs font-bold text-purple-700">Callout</span>
              <p className="text-[11px] text-purple-600 mt-1">Kısa vurgu metinleri. "Vade Farksız 6 Taksit", "Ücretsiz Kargo" gibi.</p>
            </div>
            <div className="rounded-xl p-4 border border-teal-100 bg-teal-50/50">
              <span className="text-xs font-bold text-teal-700">Structured Snippet</span>
              <p className="text-[11px] text-teal-600 mt-1">Kategori bazlı bilgiler. "Markalar: iPhone, iPad, MacBook" gibi.</p>
            </div>
            <div className="rounded-xl p-4 border border-amber-100 bg-amber-50/50">
              <span className="text-xs font-bold text-amber-700">Promotion</span>
              <p className="text-[11px] text-amber-600 mt-1">Kampanya/indirim uzantısı. "%10 Havale İndirimi" gibi.</p>
            </div>
          </div>
        </div>

        {/* SLIDE 4 — Tekrar Sorunu */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 space-y-5">
          <div className="flex items-center gap-2">
            <span className="text-xs font-bold text-white bg-orange-500 px-2.5 py-1 rounded-full">!</span>
            <h3 className="text-lg font-bold text-gray-900">Tekrarlayan Mesaj Sorunu</h3>
          </div>

          <div className="bg-orange-50 border border-orange-200 rounded-xl p-5">
            <div className="flex items-start gap-3">
              <AlertTriangle className="w-5 h-5 text-orange-500 flex-shrink-0 mt-0.5" />
              <div>
                <p className="text-sm font-semibold text-orange-800 mb-2">Problem: Aynı mesaj birden fazla yerde görünebilir</p>
                <p className="text-sm text-orange-700 leading-relaxed">
                  Örneğin <strong>"Vade Farksız 12 Taksit"</strong> mesajı aynı anda 3 farklı yerde görünebilir:
                </p>
              </div>
            </div>

            <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-3">
              <div className="bg-white rounded-lg p-3 border border-orange-200">
                <div className="flex items-center gap-1.5 mb-1.5">
                  <Repeat className="w-3.5 h-3.5 text-orange-500" />
                  <span className="text-xs font-bold text-orange-700">Headline'da</span>
                </div>
                <div className="bg-indigo-50 border border-indigo-200 rounded px-2 py-1.5 text-xs text-indigo-700 font-medium">
                  H3: "Vade Farksız 12 Taksit"
                </div>
              </div>
              <div className="bg-white rounded-lg p-3 border border-orange-200">
                <div className="flex items-center gap-1.5 mb-1.5">
                  <Repeat className="w-3.5 h-3.5 text-orange-500" />
                  <span className="text-xs font-bold text-orange-700">Callout'ta</span>
                </div>
                <div className="bg-purple-50 border border-purple-200 rounded px-2 py-1.5 text-xs text-purple-700 font-medium">
                  "12 Taksit Fırsatı"
                </div>
              </div>
              <div className="bg-white rounded-lg p-3 border border-orange-200">
                <div className="flex items-center gap-1.5 mb-1.5">
                  <Repeat className="w-3.5 h-3.5 text-orange-500" />
                  <span className="text-xs font-bold text-orange-700">Sitelink'te</span>
                </div>
                <div className="bg-blue-50 border border-blue-200 rounded px-2 py-1.5 text-xs text-blue-700 font-medium">
                  "12 Ay Taksit Avantajı"
                </div>
              </div>
            </div>
          </div>

          <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-5">
            <div className="flex items-start gap-3">
              <CheckCircle2 className="w-5 h-5 text-emerald-500 flex-shrink-0 mt-0.5" />
              <div className="space-y-2">
                <p className="text-sm font-semibold text-emerald-800">Bu Neden Kabul Edilebilir?</p>
                <ul className="text-sm text-emerald-700 space-y-2">
                  <li className="flex items-start gap-2">
                    <span className="text-emerald-400 mt-0.5">1.</span>
                    <span><strong>"Taksit" en önemli offer'larımızdan biri.</strong> Kullanıcıların bu bilgiyi farketmesini garanti altına almak için birden fazla yerde yer alması stratejik olarak kabul edilebilir.</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-emerald-400 mt-0.5">2.</span>
                    <span><strong>Google her zaman tüm extension'ları aynı anda göstermez.</strong> Bir gösterimde sitelink çıkarken callout çıkmayabilir — yani kullanıcı tekrarı her seferinde görmez.</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-emerald-400 mt-0.5">3.</span>
                    <span><strong>Extension'ları kaldırmak, reklam puanını ve kalite skorunu ciddi düşürür.</strong> Extension kullanımı Ad Rank hesaplamasında doğrudan etkili bir faktördür.</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* SLIDE 5 — Extension Neden Zorunlu */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 space-y-5">
          <div className="flex items-center gap-2">
            <span className="text-xs font-bold text-white bg-blue-600 px-2.5 py-1 rounded-full">4</span>
            <h3 className="text-lg font-bold text-gray-900">Tüm Extension'ları Kullanmak Neden Zorunlu?</h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="rounded-xl p-5 border-2 border-blue-200 bg-gradient-to-br from-blue-50 to-white space-y-3">
              <div className="flex items-center gap-2">
                <BarChart3 className="w-5 h-5 text-blue-600" />
                <span className="font-semibold text-gray-900">Ad Rank Formülü</span>
              </div>
              <div className="bg-white rounded-lg p-4 border border-blue-100 text-center">
                <p className="text-sm font-mono text-gray-700">
                  <span className="text-blue-700 font-bold">Ad Rank</span> = Teklif x Kalite Skoru x <span className="text-orange-600 font-bold underline decoration-orange-300 decoration-2 underline-offset-2">Extension Etkisi</span>
                </p>
              </div>
              <p className="text-xs text-gray-600">
                Extension kullanımı doğrudan <strong>Ad Rank'i</strong> etkiler. Extension'sız bir reklam, aynı teklif ve kalite skorunda bile daha düşük sıralarda gösterilir.
              </p>
            </div>
            <div className="rounded-xl p-5 border-2 border-emerald-200 bg-gradient-to-br from-emerald-50 to-white space-y-3">
              <div className="flex items-center gap-2">
                <Zap className="w-5 h-5 text-emerald-600" />
                <span className="font-semibold text-gray-900">Extension Faydaları</span>
              </div>
              <div className="space-y-2">
                {[
                  'Reklam alanı büyür, rakip reklamları aşağı iter',
                  'CTR (tıklama oranı) ortalama %10-15 artar',
                  'Kalite skoru yükselir, tıklama maliyeti düşer',
                  'Kullanıcıya daha fazla bilgi ve seçenek sunulur',
                  'Google, reklamı daha sık ve üst sıralarda gösterir',
                ].map((item, i) => (
                  <div key={i} className="flex items-start gap-2 text-xs text-gray-700">
                    <CheckCircle2 className="w-3.5 h-3.5 text-emerald-500 flex-shrink-0 mt-0.5" />
                    <span>{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* SLIDE 6 — Strateji Özeti */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 space-y-5">
          <div className="flex items-center gap-2">
            <span className="text-xs font-bold text-white bg-blue-600 px-2.5 py-1 rounded-full">5</span>
            <h3 className="text-lg font-bold text-gray-900">Strateji Özeti</h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="bg-slate-50 rounded-xl p-5 border border-slate-200 space-y-3">
              <div className="w-10 h-10 bg-indigo-100 rounded-xl flex items-center justify-center">
                <Puzzle className="w-5 h-5 text-indigo-600" />
              </div>
              <h4 className="font-semibold text-gray-900">Headline Çeşitliliği</h4>
              <p className="text-xs text-gray-600 leading-relaxed">
                15 headline'ın her biri farklı bir açıdan konuşmalı: ürün adı, fiyat avantajı, garanti, marka güveni, kampanya.
                Böylece Google en uygun kombinasyonu oluşturabilir ve tekrar riski azalır.
              </p>
            </div>
            <div className="bg-slate-50 rounded-xl p-5 border border-slate-200 space-y-3">
              <div className="w-10 h-10 bg-orange-100 rounded-xl flex items-center justify-center">
                <Pin className="w-5 h-5 text-orange-600" />
              </div>
              <h4 className="font-semibold text-gray-900">Pinning (Sabitleme)</h4>
              <p className="text-xs text-gray-600 leading-relaxed">
                Kritik mesajları belirli pozisyonlara sabitleyerek, her varyasyonda o mesajın mutlaka görünmesini sağlarız.
                Ancak fazla sabitleme Google'ın optimizasyon alanını daraltır — dikkatli kullanılmalı.
              </p>
            </div>
            <div className="bg-slate-50 rounded-xl p-5 border border-slate-200 space-y-3">
              <div className="w-10 h-10 bg-emerald-100 rounded-xl flex items-center justify-center">
                <Layers className="w-5 h-5 text-emerald-600" />
              </div>
              <h4 className="font-semibold text-gray-900">Extension Stratejisi</h4>
              <p className="text-xs text-gray-600 leading-relaxed">
                Tüm extension türleri aktif olmalı. Küçük tekrarlar kabul edilebilir çünkü Google her gösterimde farklı kombinasyonlar sunar.
                Extension'sız reklam = eksik reklam.
              </p>
            </div>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 flex items-start gap-3">
            <Info className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" />
            <p className="text-sm text-blue-800">
              <strong>Sonuç:</strong> Headline ve extension'larda zaman zaman benzer mesajlar yer alabilir (ör. "12 taksit").
              Bu Google Ads'in yapısından kaynaklanan doğal bir durumdur. Önemli olan tüm extension'ları aktif tutarak
              <strong> reklam puanını, kalite skorunu ve gösterim sıklığını</strong> en üst seviyede tutmaktır.
              Google'ın AI'ı kullanıcıya en uygun kombinasyonu zaten otomatik olarak seçmektedir.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
